import React, {Component} from 'react'
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {zoomIntegrationActions} from "../_actions";
import queryString from 'query-string'
import LoaderMessage from "../_components/LoaderMessage";
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {ZoomIntegrationDefault} from "../components/zoomIntegration/ZoomIntegrationDefault";
import {__isKeyAvailable} from "../_helpers/commons/utility.helper";

// COMPONENT ##########################################################

class ZoomIntegrationHome extends Component {

    constructor(props) {
        super(props);

        this.initiateIntegration = this.initiateIntegration.bind(this);
    }

    componentDidMount() {
        // if authorization code present - authorize first
        const query = queryString.parse(this.props.location.search);
        if (query && query.code) {
            this.initiateIntegration(query.code);
        }
    }

    initiateIntegration(code) {
        this.props.connectUsingAuthorizationCode(code);  // integration-request using code
    }

    isAuthorizing = () => {
        const {zoom} = this.props;
        return __isKeyAvailable(zoom, "connect");
    };

    render() {
        const {t, alert} = this.props;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header />

                        {/* if authorization is going on */}
                        { this.isAuthorizing() &&
                            LoaderMessage({
                                title: t("Zoom Integration"),
                                messages: [],
                                alert: alert,
                                loadingText: t("Authorizing Zoom credentials...")
                            })
                        }

                        {/* if no pending authorization */}
                        { !this.isAuthorizing() &&
                            // if load default landing page
                            <ZoomIntegrationDefault/>
                        }
                    <Footer />
                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state){
    const {alert} = state;
    return {
        alert
    }
}

function mapDispatchToProps(dispatch) {
    return {
        connectUsingAuthorizationCode: (code)               => dispatch(zoomIntegrationActions.connect(code)),
    }
}

const connectedZoomIntegrationHome = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ZoomIntegrationHome));
export { connectedZoomIntegrationHome as ZoomIntegrationHome };
